import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './App.css';

// Helper function to remove markdown formatting and try to parse JSON.
const cleanAndParseCharacters = (characterData) => {
  if (!characterData) return null;
  let cleanedData = characterData.trim();
  if (cleanedData.startsWith("```json")) {
    cleanedData = cleanedData.replace(/^```json\s*/, "").replace(/\s*```$/, "");
  }
  try {
    return JSON.parse(cleanedData);
  } catch (e) {
    console.error("Error parsing character JSON:", e);
    return null;
  }
};

// Helper function to check if the character details are incomplete
const isIncompleteCharacters = (characterData) => {
  if (!characterData) return false;
  let cleanedData = characterData.trim();
  if (cleanedData.startsWith("```json")) {
    cleanedData = cleanedData.replace(/^```json\s*/, "").replace(/\s*```$/, "");
  }
  try {
    JSON.parse(cleanedData);
    return false;
  } catch (e) {
    return true;
  }
};

function App() {
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEpisodes();
  }, []);

  const fetchEpisodes = async () => {
    setLoading(true);
    try {
      // Adjust the URL if your backend runs on a different host/port
      const response = await axios.get('https://zarword-backend.onrender.com/update_episodes');
      setEpisodes(response.data);
    } catch (error) {
      console.error("Error fetching episodes:", error);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to render character details.
  // If parsing fails, displays the raw JSON.
  const renderCharacters = (characterData) => {
    const parsedData = cleanAndParseCharacters(characterData);
    if (parsedData && Array.isArray(parsedData)) {
      return (
        <div className="character-list">
          {parsedData.map((char, idx) => (
            <div key={idx} className="character-card">
              <h4>{char.name}</h4>
              <p><strong>Involvement:</strong> {char.involvement}</p>
              <p><strong>Abilities:</strong> {char.abilities}</p>
            </div>
          ))}
        </div>
      );
    } else {
      return (
        <div className="character-details">
          <pre>{characterData}</pre>
        </div>
      );
    }
  };

  return (
    <div className="App">
      <header className="app-header">
        <h1>Zarword Explorer</h1>
        <p>Discover and Explore Your Favorite Podcast Episodes</p>
      </header>
      <main className="episode-container">
        {loading ? (
          <div className="loader">Loading episodes...</div>
        ) : episodes.length === 0 ? (
          <div className="no-data">No episodes available.</div>
        ) : (
          episodes.map((episode, index) => (
            <div key={index} className="episode-card">
              <div className="episode-header">
                <h2>{episode.title}</h2>
                <span className="pub-date">{episode.pub_date}</span>
              </div>
              {/* Render description as HTML */}
              <div
                className="episode-description"
                dangerouslySetInnerHTML={{ __html: episode.description }}
              ></div>
              <div className="episode-section">
                <h3>
                  Characters
                  {isIncompleteCharacters(episode.characters) && (
                    <span className="incomplete-mark" title="Incomplete character details"> * incomplete infomation</span>
                  )}
                </h3>
                {renderCharacters(episode.characters)}
              </div>
              <div className="episode-section">
                <h3>Summary</h3>
                <p>{episode.summary}</p>
              </div>
              <div className="platform-links">
                <a href={episode.audio_url} target="_blank" rel="noopener noreferrer">
                  Listen / Download Episode
                </a>
              </div>
            </div>
          ))
        )}
      </main>
      <footer className="app-footer">
        <p>© 2025 Zarword Explorer. All Rights Reserved.</p>
      </footer>
    </div>
  );
}

export default App;